<template>

    <div>
        <div class="row  no-gutters pt-xl-4 mb-xl-6">
            <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

            </div>
            <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
                 v-if="lesson">
                {{lesson.lesson}}
            </div>
            <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points">
                <div class="zerno-points">
                    {{points}}
                </div>
            </div>
            <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
                <div class="tab-video-notice-1">{{ $t('test') }} {{$t('№')}}{{ test.pos }}
                    <span class="ml-2" v-if="testsCount > 0">({{test.pos}} {{$t('of')}} {{testsCount}})</span>
                </div>
            </div>

            <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

                <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
                <h2 class="mt-7" v-else>{{ $t('test') }} {{$t('№')}}{{ test.pos }}</h2>
                <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
                <button
                        class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
                        @click="startTest">
                    <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{$t('№')}}{{ test.pos }}
                </button>

            </div>

            <div class="col-12 order-10" v-if="!showTestIntro && test">
                <h2 class="col-12 mb-3 text-center">{{currentTask.testtask}}</h2>
                <div class="col-12 h3 text-center">Твое время: {{timerText}}</div>
                <div v-if="result=='correct'" class="row">
                    <div class="col-12 mb-4 text-center">
                        <img src="poliimg/excellent.png"
                             class="test-image"
                             style="width: 250px"
                        >
                    </div>
                </div>
                <div v-else class="row justify-content-center mb-4">
                    <table style="cursor: pointer;">
                        <tr v-for="r in tablesize" :key="r">
                            <td v-for="c in tablesize" :key="c">
                                <div
                                    :class="['display-1', 'text-center', 'digit-cell', upturned?'upturned':'', items[c-1 + (r-1) * tablesize].color ]"
                                    @click="cellclick(items[c-1 + (r-1) * tablesize])"
                                >
                                    {{ items[c-1 + (r-1) * tablesize].num }}
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>


        </div>
        <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
            <button
                    class="btn btn-info"
                    @click="skip"
            >
                {{ $t('omit_task') }} &rarr;
            </button>
        </div>
    </div>


</template>

<style>
    .v-chip__content {
        font-size: 40px;
        font-weight: 500;
    }
    @media (min-width: 1024.1px) {
      .digit-cell {
        border: 1px solid black;
        width: 70px;
        height: 70px;
      }
    }
    @media (max-width: 1024px) {
      .digit-cell {
        border: 1px solid black;
        width: 35px;
        height: 35px;
        font-size: 22px;
        line-height: 35px;
      }
    }
</style>

<script>
    import Vue from 'vue'
    import api from '@/utils/api'

    export default {
        name: 'Test21',
        props: {
            idtest: {default: null},
            lesson: {type: Object, default: null},
            points: {default: null},
            testsCount: {default: null},
            showButtons: {type: Boolean, default: true},
        },
        data: () => ({
            test: {},
            testtasks: [],
            testelements: [],
            taskIdx: 0,
            audio: new Audio(),
            result: null,

            tablesize: 0,
            direction: 'inc',
            upturned: false,
            redblack: false,
            items: [],
            lastIdx: null,

            timerSeconds: 0,
            timer: null,

            errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
            okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',
            showTestIntro: true,
        }),

        computed: {
            currentTask: function () {
                console.log('currentTask')
                return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
            },

            mainElement: function () {
                return this.testelements.length ? this.testelements[0] : {}
            },

            answers: function () {
                console.log('answers')
                return this.testelements.filter(function (e) {
                    return !e.ismain
                })
            },

            timerText() {
                const sec = this.timerSeconds % 60
                const min = Math.trunc(this.timerSeconds / 60)
                return min.toString().padStart(2, "0") + ':' + sec.toString().padStart(2, "0")
            },
        },

        watch: {
            taskIdx: async function () {
                this.loadTask()
            },
        },

        async mounted() {
            document.onselectstart = new Function("return false");
            api({url: '/tests/' + this.idtest}).then(resp => {
                this.test = resp.data
            })
            const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
            this.testtasks = response.data
            this.loading = false
        },
        methods: {
            async startTest() {
                if (this.testtasks.length) {
                    if (this.test.audio) {
                        await this.play(this.test.audio)
                    }
                    this.showTestIntro = false
                    this.loadTask()
                }
            },
            async loadTask() {
                this.result = null
                if (this.currentTask.idtesttask) {
                    let tablesize = this.currentTask.tablesize
                    this.redblack = !!this.currentTask.redblack
                    this.direction = this.currentTask.reverse ? 'dec' : 'inc'
                    this.upturned = !!this.currentTask.upturned

                    console.log(this.currentTask)
                    if(this.redblack) {
                        const mid = parseInt((tablesize * tablesize)/2)
                        this.items = this.shuffle( Array(tablesize * tablesize).fill().map((item, index) => ({
                            idx: index,
                            num: index>mid ? index-mid : index+1,
                            color: index>mid ? 'bg-red' : 'bg-black'
                        })) )
                    } else {
                        this.items = this.shuffle( Array(tablesize * tablesize).fill().map((item, index) => ({
                            idx: index,
                            num:index+1,
                            color: ''
                        })) )
                    }

                    this.lastIdx = this.direction=='dec' ? this.items.length : -1
                    this.tablesize = this.currentTask.tablesize
                    this.startTimer()
                    console.log(this.taskIdx, this.currentTask, this.items)
                } else {
                    this.$emit('testComplete')
                }
            },
            getBy(propname, value, array) {
                for (let index = 0; index < array.length; index++) {
                    if (array[index][propname] === value) return array[index]
                }

                return {}
            },

            shuffle(a) {
                for (let i = a.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [a[i], a[j]] = [a[j], a[i]]
                }
                return a
            },

            shuffleFull(items) {
                const originalState = items.map(a => ({...a})) // clone

                for (let i = 0; i < 1000; i++) {
                    items = this.shuffle(items)
                    let wrongPlace = false
                    items.forEach((e, i) => {
                        if (e.idtestelement === originalState[i].idtestelement) wrongPlace = true
                    })
                    if (!wrongPlace) {
                        console.log('Shuffle tryes: ' + i)
                        break
                    }
                }

                return items
            },

            play: function (path) {
                return new Promise((resolve) => {
                    if (path) {
                        this.audio.src = path
                        this.audio.play()
                        this.audio.onended = function () {
                            console.log('Звук закончился')
                            resolve()
                        }

                        this.audio.onerror = function () {
                            console.log('Звук error')
                            resolve()
                        }
                    } else {
                        resolve()
                    }
                })
            },

            sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },

            async cellclick(item) {
                console.log(this.direction, item.idx, this.lastIdx)
                if( (this.direction == 'inc' && item.idx == this.lastIdx+1) || (this.direction == 'dec' && item.idx == this.lastIdx-1)) {
                    Vue.set(item, 'color', 'bg-green')
                    this.play(this.okChord)
                    this.lastIdx = item.idx
                    this.$emit('correctAnswer')

                    for (const i in this.items)
                        if (this.items[i].color != 'bg-green') return;

                    this.result = 'correct'
                    this.stopTimer()

                    await this.sleep(3000)

                    if(this.currentTask.cnt > 1)  {
                        this.currentTask.cnt--
                        this.loadTask()
                        return
                    }

                    this.taskIdx++
                } else {
                    this.play(this.errorChord)
                }
            },

            startTimer() {
                if(this.timer !== null) clearTimeout(this.timer)
                this.timerSeconds = 0
                this.timer = setInterval(() => {
                    this.timerSeconds++
                }, 1000)
                console.log('start timer', this.timer)
            },

            stopTimer() {
                clearTimeout(this.timer)
                console.log('stop timer')
            },

            skip: function () {
                this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
                this.taskIdx++
            },
        },

        destroyed() {
            this.stopTimer()
        },
    }
</script>
